import { render, staticRenderFns } from "./HistoryAnimalAdding.vue?vue&type=template&id=5c0aed2c&scoped=true&"
import script from "./HistoryAnimalAdding.vue?vue&type=script&lang=js&"
export * from "./HistoryAnimalAdding.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAnimalAdding.vue?vue&type=style&index=0&id=5c0aed2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0aed2c",
  null
  
)

export default component.exports